import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
// PrimeReact global styles (theme + core + icons)
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
// PrimeFlex utilities (spacing, flex, text) used for compact sizing adjustments
import "primeflex/primeflex.css";
import { loadPracticeSiteSheet } from "./services/hierarchyLoader";
import TaskPaneApp from "./ui/TaskPaneApp";
// Bootstrap Office then load hierarchy then mount React
Office.onReady(async (info) => {
    if (info.host !== Office.HostType.Excel)
        return;
    try {
        await loadPracticeSiteSheet();
    }
    catch (e) {
        console.error("Failed to load hierarchy", e);
    }
    const mountEl = ensureMount();
    const root = createRoot(mountEl);
    root.render(_jsx(TaskPaneApp, {}));
    revealAppBody();
});
function ensureMount() {
    let el = document.getElementById("app-react");
    if (!el) {
        el = document.createElement("div");
        el.id = "app-react";
        document.body.appendChild(el);
    }
    return el;
}
function revealAppBody() {
    const sideload = document.getElementById("sideload-msg");
    if (sideload)
        sideload.style.display = "none";
    const appBody = document.getElementById("app-body");
    if (appBody)
        appBody.style.display = "block";
}
